export default __webpack_public_path__ + "static/media/mainBcg.2e4ed4d7.jpeg";